import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from "react-multi-date-picker";

import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import LoadingComponent from '../../../layouts/nav/loading';

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const getStartOfWeek = (date) => {
    const day = date.getDay(), // get the current day of the week
        diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
    const startOfWeek = new Date(date.setDate(diff));
    startOfWeek.setHours(0, 0, 0, 0); // set to midnight
    return startOfWeek;
};

const getEndOfWeek = (date) => {
    const day = date.getDay(),
        diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
    const endOfWeek = new Date(date.setDate(diff));
    endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
    return endOfWeek;
};

const Subscription = () => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [loading, setLoading] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);

    // page table data fetch
    const fetchData = (filter = {}) => {
        setLoading(true);
        const params = {
            ...filter,      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm,  // add search string
            branch_id: branch_id
        };
        axios.get(`${baseURL}/payment/history`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
                setLoading(false);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
                setLoading(false);
            });
    };

    useEffect(() => {
        handleGoClick();
    }, [page, searchTerm, perPage]);

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    const tableRef = useRef(null);
    const [filterOpen, setFilterOpen] = useState(false);
    const onClose = () => {
        setFilterOpen(false);
    };

    // ------------------------------------------- Filter Details -------------------------------
    // prods option & on select
    const [filter_prods_id, setFilterProdsID] = useState(null);
    const [productsOpt, setProductsOpt] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/manage-products/products/active`)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.product_name,
                }));
                const allOption = { value: null, label: "All" };
                setProductsOpt([allOption, ...formatted]);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    // timeline option & on select
    const [filter_tline_id, setFilterTlineID] = useState(null);
    const [timelineoptions, setTimelineoption] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/package-timeline/active`)
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.packagetimeline_name,
                }));
                const allOption = { value: null, label: "All" };
                setTimelineoption([allOption, ...formatted]);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    //area
    const [areaOption, setAreaOption] = useState([]);
    const [area, setArea] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/area`, { params: { branch_id } });
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.area_name,
                }));
                const allOption = { value: null, label: "All" };
                setAreaOption([allOption, ...formattedsource]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    // delivery point
    const [dppoption, setdpoption] = useState([]);
    const [dp, setDp] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/deliverypoint`, { params: { branch_id } });
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.delivery_point,
                }));
                const allOption = { value: null, label: "All" };
                setdpoption([allOption, ...formattedsource]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(getStartOfWeek(new Date()));
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(getEndOfWeek(new Date()));
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];

    const [status, setstatus] = useState(null);
    const handleGoClick = () => {

        const filter = {
            status: status ? status.value : null,
            date_filter: date_fil_selt_value || '',
        };
        if (date_fil_selt_value === 'custom') {
            filter.start_date = custom_stdt_fil_value || '';
            filter.end_date = custom_eddt_fil_value || '';
        }
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData(filter);
        onClose();
    };

    // ------------------------------------------------------ Export ---------------------------------------------------
    const exportCSV = async () => {
        try {
            const filter = {
                product: filter_prods_id || '',
                timeline: filter_tline_id || '',
                area: area || '',
                delivery_point: dp || '',
                date_filter: date_fil_selt_value || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id,
            };

            const response = await axios.get(`${baseURL}/subscription/drop`, { params });
            const allData = response.data.data;

            const columnNames = [
                'S.No', 'Subscriber Name', 'Mobile No', 'Email ID',
                'Area',
                // 'Latitude', 'Longitude', 
                'Address', 'Product', 'Drop Date', 'Drop Reason'
            ];
            const formattedData = allData.map((item, index) => ({
                'S.No': index + 1,
                'Subscriber Name': item.lead_name,
                'Mobile No': item.lead_mobile_no,
                'Email ID': item.lead_email_id || '-',
                'Area': item.arearelation.area_name || '-',
                // 'Latitude': item.latitude || '-',
                // 'Longitude': item.longitude || '-',
                'Address': item.address || '-',
                'Product': item.product_name || '-',
                'Drop Date': formatDate(item.drop_date),
                'Drop Reason': item.drop_reason || '-',
            }));
            const csv = Papa.unparse({
                fields: columnNames,
                data: formattedData
            });
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'drop.csv';
            link.click();
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const exportExcel = async () => {
        try {

            const filter = {
                product: filter_prods_id || '',
                timeline: filter_tline_id || '',
                area: area || '',
                delivery_point: dp || '',
                date_filter: date_fil_selt_value || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id,
            };

            const response = await axios.get(`${baseURL}/subscription/drop`, { params });
            const allData = response.data.data;

            // Format the data to include the desired columns

            const formattedData = allData.map((item, index) => ({
                'S.No': index + 1,
                'Subscriber Name': item.lead_name,
                'Mobile No': item.lead_mobile_no,
                'Email ID': item.lead_email_id || '-',
                'Area': item.arearelation.area_name || '-',
                // 'Latitude': item.latitude || '-',
                // 'Longitude': item.longitude || '-',
                'Address': item.address || '-',
                'Product': item.product_name || '-',
                'Drop Date': formatDate(item.drop_date),
                'Drop Reason': item.drop_reason || '-',
            }));

            // Create worksheet from formatted data
            const ws = XLSX.utils.json_to_sheet(formattedData);

            // Create a new workbook and append the worksheet
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

            // Write the workbook to an Excel file and trigger the download
            XLSX.writeFile(wb, 'drop.xlsx');
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    const print = async () => {
        try {
            const filter = {
                product: filter_prods_id || '',
                timeline: filter_tline_id || '',
                area: area || '',
                delivery_point: dp || '',
                date_filter: date_fil_selt_value || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            const params = {
                ...filter,
                search: searchTerm,
                per_page: 'all',
                branch_id: branch_id,
            };

            const response = await axios.get(`${baseURL}/subscription/drop`, { params });
            const allData = response.data.data;
            // Define the column names for printing
            const columnNames = [
                'S.No', 'Subscriber Name', 'Mobile No', 'Email ID',
                'Area',
                // 'Latitude', 'Longitude', 
                'Address', 'Product', 'Drop Date', 'Drop Reason'
            ];
            const formattedData = allData.map((item, index) => ({
                'S.No': index + 1,
                'Subscriber Name': item.lead_name,
                'Mobile No': item.lead_mobile_no,
                'Email ID': item.lead_email_id || '-',
                'Area': item.arearelation.area_name || '-',
                // 'Latitude': item.latitude || '-',
                // 'Longitude': item.longitude || '-',
                'Address': item.address || '-',
                'Product': item.product_name || '-',
                'Drop Date': formatDate(item.drop_date),
                'Drop Reason': item.drop_reason || '-',
            }));

            // Create an HTML table for printing
            let printContent = `<table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
                <thead>
                    <tr style="background-color: #f2f2f2;">`;

            // Add column headers
            columnNames.forEach(col => {
                printContent += `<th style="padding: 8px; text-align: left; border: 1px solid #ddd;">${col}</th>`;
            });

            printContent += `</tr></thead><tbody>`;

            // Add the rows of data
            formattedData.forEach(row => {
                printContent += `<tr>`;
                columnNames.forEach(col => {
                    printContent += `<td style="padding: 8px; border: 1px solid #ddd;">${row[col]}</td>`;
                });
                printContent += `</tr>`;
            });

            printContent += `</tbody></table>`;

            // Open the print dialog
            const printWindow = window.open('', '', 'height=800,width=1000');
            printWindow.document.write('<html><head><title>Lead Details</title>');
            printWindow.document.write('<style>table { width: 100%; border-collapse: collapse; }</style>');
            printWindow.document.write('</head><body>');
            printWindow.document.write(printContent);
            printWindow.document.write('</body></html>');
            printWindow.document.close(); // Necessary for IE >= 10
            printWindow.print();
        } catch (error) {
            console.error('Export failed:', error);
            toast.error("Export Faild");
        }
    };

    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    function formatTime(timeStr) {
        if (timeStr) {
            const [hours, minutes] = timeStr.split(':');
            const date = new Date();
            date.setHours(parseInt(hours));
            date.setMinutes(parseInt(minutes));
            return date
                .toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })
                .toUpperCase();  // Force AM/PM to uppercase
        } else {
            return '';
        }
    }

    const handleModalVerify = (data) => {
        axios.post(`${baseURL}/payment/verify/${data.sno}`)
            .then((result) => {
                fetchData();
                toast.success("Payment Verified Successfully!");
            })
            .catch(error => {
                console.log(error);
                toast.error("Payment Verification Failed");
            });
    };

    const option_status = [
        { value: 0, label: "Not Verified" },
        { value: 1, label: "Verified" }
    ];

    const [isMaintenance, setIsMaintenance] = useState(false);
    // const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "payments-management"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);

    // if (loading) {
    //     return <div>Loading...</div>; // optional loading state
    // }

    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage Payment Management </strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }

    return (
        <>
            {loading ? (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}><Skeleton width={150} /></h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Skeleton width={70} /></li>
                            <li className="breadcrumb-item"><Skeleton width={20} /></li>
                            <li className="breadcrumb-item active"><Skeleton width={100} /></li>
                        </ol>
                    </div>
                    <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
                        <Skeleton width={100} height={30} />
                    </div>
                </div>
            ) : (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}>Manage History</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                            <li className="breadcrumb-item active">Payment Management</li>
                        </ol>
                    </div>
                    <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
                        <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                            <span className='me-2'><i className="fa-solid fa-filter fs-8"></i></span>
                            <span className=''>Filter</span>
                        </Link>
                    </div>
                </div>
            )}


            {/* <LoadingComponent loading={loading} /> */}
            {loading ? (
                <div className="table-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2"><Skeleton width={50} height={25} /></label>
                            <Skeleton width={50} height={25} className="mb-1" />
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <Skeleton width={150} height={25} className="mb-1" />
                        </div>
                    </div>

                    <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {[...Array(perPage)].map((_, i) => (
                                <tr key={i}>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                    <td><Skeleton /></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            <Skeleton width={180} height={15} />
                        </div>

                        {/* Bottom right: Pagination */}
                        <nav>
                            <div className="d-flex gap-2">
                                {[...Array(4)].map((_, i) => (
                                    <Skeleton key={i} width={40} height={25} borderRadius={5} />
                                ))}
                            </div>
                        </nav>
                    </div>
                </div>
            ) : (
                <div className="table-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{ fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1); // Reset to first page
                                }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <input
                                type="text"
                                style={{ fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1); // Reset page on new search
                                }}
                            />
                        </div>
                    </div>

                    <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className='min-w-100px'>Subscriber</th>
                                <th className='min-w-100px'>Payment Date</th>
                                <th className='min-w-100px'>Payment Mode</th>
                                <th className='min-w-125px'>GST</th>
                                <th className='min-w-125px'>Total Amount</th>
                                <th className='min-w-50px text-center'>Status</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {datas.length === 0 && hasFetched ? (
                                <tr>
                                    <td colSpan="6" className="text-center text-muted py-2">
                                        No data available
                                    </td>
                                </tr>
                            ) : (
                                <>
                                    {datas.map((data, index) => (
                                        <tr key={data.sno}>
                                            <td>
                                                <div className='text-black font-w400 fs-7 text-wrap mw-auto'>{capitalizeFirstLetter(data.subscriber_name)}</div>
                                                <div className='d-block'>
                                                    <div className='text-dark font-w500 fs-8'>{data.subscriber_mobile_no}</div>
                                                </div>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{formatDate(data.created_at)}</label>
                                                <div className='d-block'>
                                                    <label className='text-dark font-w600 fs-8'>{formatTime(data.created_at)}</label>
                                                </div>
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{data.payment_mode_name}</label>
                                                {data.transaction_id && (
                                                    <div className='d-block'>
                                                        <label className='text-dark font-w600 fs-8'>{data.transaction_id}</label>
                                                    </div>
                                                )}
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                <label className='text-info fw-bold fs-7'>
                                                    <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                    <span>{data.gst_amount}</span>
                                                </label>
                                            </td>
                                            <td style={{ textAlign: 'right' }}>
                                                <label className='text-danger fw-bold fs-7'>
                                                    <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                    <span>{data.total_amount}</span>
                                                </label>
                                            </td>
                                            <td className='text-center align-content-center'>
                                                {data.verification_status === 1 ? (
                                                    <>
                                                        <label className="text-white fs-7 py-0 px-1 badge bg-success me-2">Verified</label>
                                                        {/* {data.is_online == 1 && ( */}
                                                        {/* <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Invoice</span></Tooltip>} >
                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" href={`/payment-invoice?data=${encodeURIComponent(btoa(JSON.stringify({ sno: data.sno })))}`} target='_blank' >
                                                                <span><i className="fa-solid fa-file-invoice fs-6 mt-1"></i></span>
                                                            </Button>
                                                        </OverlayTrigger> */}
                                                        {/* )} */}
                                                    </>
                                                ) : (
                                                    <>
                                                        <Dropdown drop="">
                                                            <Dropdown.Toggle as="a" className={`i-false cursor-pointer `}>
                                                                <Badge bg="none" className='py-1 px-2 fs-8 text-black' style={{ background: '#aaaaaaff' }}>Waiting for Approval</Badge>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu >
                                                                <Dropdown.Item href="#" className='text-black' onClick={() => handleModalVerify(data)}>Verify Payment</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </>
                            )}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            {datas.length > 0 ? (
                                <span className="text-muted">
                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                </span>
                            ) : (
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            )}
                        </div>

                        {/* Bottom right: Pagination */}
                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                {/* Previous Button */}
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                        Previous
                                    </button>
                                </li>

                                {/* First Page */}
                                <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                        1
                                    </button>
                                </li>

                                {/* Left Ellipsis */}
                                {page > 4 && (
                                    <li className="page-item disabled">
                                        <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                    </li>
                                )}

                                {/* Pages Around Current */}
                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                    .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                    .map(p => (
                                        <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                                {p}
                                            </button>
                                        </li>
                                    ))}

                                {/* Right Ellipsis */}
                                {page < totalPages - 3 && (
                                    <li className="page-item disabled">
                                        <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                    </li>
                                )}

                                {/* Last Page */}
                                {totalPages > 1 && (
                                    <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                            {totalPages}
                                        </button>
                                    </li>
                                )}

                                {/* Next Button */}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            )}

            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Drop Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>

                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Status</label>
                                <Select placeholder="Select Status"
                                    options={option_status}
                                    onChange={setstatus}
                                    value={status}
                                />
                            </div>

                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            // value={"05/18/2020 02:20:36 PM"}
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY"
                                            // format="DD/MM/YYYY hh:mm:ss A"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1 mb-1">
                        <Button className="me-2 btn-sm" variant="secondary" onClick={() => {
                            setFilterProdsID(null);
                            setFilterTlineID(null);
                            setDateFilSeltValue('all');
                            setArea(null);
                            setDp(null);
                            setstatus(null);
                            fetchData();
                            onClose();
                            // window.location.reload();
                        }}>
                            <span className='font-w400'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary" onClick={handleGoClick}>
                            <span className='font-w400'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>
        </>
    )


}
export default Subscription;